import md5 from 'md5';
/* eslint-disable */
const salt = 'ifeng';
/**
 * 防盗链sign计算函数
 * @param {Object} info
 * @param {string} info.gid - 视频Id
 * @param {string} info.pver - 播放器版本
 * @param {string} info.sver - APP版本
 * @param {string} info.tm - 时间戳
 * @param {string} info.uid - 用户id
 * @param {string} info.vid - 视频请求唯一ID
 * @return {object}
 */
const genSign = function({ gid = '', pver = '', sver = '', tm = Date.now(), uid = '', vid = '' }) {
    const paramArr = [];

    paramArr.push(`gid=${gid}`);
    paramArr.push(`pver=${pver}`);
    paramArr.push(`sver=${sver}`);
    paramArr.push(`tm=${tm}`);
    paramArr.push(`uid=${uid}`);
    paramArr.push(`vid=${vid}`);

    const md5String = paramArr.join('&') + salt;

    const sign = md5(md5String);

    return { sign, tm };
};

export default genSign;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.util/app/lib/auth/utils/sign.js